import React from 'react';
import { NavLink } from 'react-router-dom';
import { Facebook, Twitter, Instagram, Youtube, Mail, MapPin, Phone } from 'lucide-react';
import './FooterNew.css';
import logoImg from '../img/Untitled design (19).png';

export default function Footer() {
  return (
    <footer className="main-footer">
      <div className="footer-container">
        {/* 1. Brand & About */}
        <div className="footer-column brand-column">
          <div className="footer-logo">
            <span className="logo-text">CodeWave</span>
          </div>
          <p className="footer-desc">
            نحن نصنع المستقبل من خلال تعليم البرمجة للأجيال القادمة بطريقة ممتعة ومبسطة. منصتنا تفتح آفاقاً جديدة للأطفال والشباب من سن 6 إلى 18 عاماً.
          </p>
          <div className="social-links">
            <a href="https://facebook.com" aria-label="Facebook"><Facebook size={20} /></a>
            <a href="https://twitter.com" aria-label="Twitter"><Twitter size={20} /></a>
            <a href="https://instagram.com" aria-label="Instagram"><Instagram size={20} /></a>
            <a href="https://youtube.com" aria-label="Youtube"><Youtube size={20} /></a>
          </div>
        </div>

        {/* 2. Quick Links */}
        <div className="footer-column">
          <h4 className="footer-title">روابط سريعة</h4>
          <ul className="footer-links">
            <li><NavLink to="/">الرئيسية</NavLink></li>
            <li><NavLink to="/lessons">الدروس</NavLink></li>
            <li><NavLink to="/dashboard">الأسعار والخطط</NavLink></li>
            <li><NavLink to="/about">عن المنصة</NavLink></li>
          </ul>
        </div>

        {/* 3. Learning Paths */}
        <div className="footer-column">
          <h4 className="footer-title">مسارات التعلم</h4>
          <ul className="footer-links">
            <li><NavLink to="/lessons">Scratch للمبتدئين</NavLink></li>
            <li><NavLink to="/lessons">برمجة Python</NavLink></li>
            <li><NavLink to="/lessons">تطوير الويب</NavLink></li>
            <li><NavLink to="/ai-tutor">المساعد الذكي</NavLink></li>
          </ul>
        </div>

        {/* 4. Contact Info */}
        <div className="footer-column contact-column">
          <h4 className="footer-title">تواصل معنا</h4>
          <ul className="contact-list">
            <li>
              <Phone size={18} className="contact-icon" />
              <span>+01021406649</span>
            </li>
            <li>
              <Mail size={18} className="contact-icon" />
              <span>codeewaveeofficial@gmail.com</span>
            </li>
            <li>
              <MapPin size={18} className="contact-icon" />
              <span>القاهرة، جمهورية مصر العربية</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="footer-bottom-container">
          <p className="copyright">
            © {new Date().getFullYear()} كود ويف (Code Wave). جميع الحقوق محفوظة.
          </p>
          <div className="legal-links">
            <NavLink to="/privacy">سياسة الخصوصية</NavLink>
            <NavLink to="/terms">شروط الاستخدام</NavLink>
          </div>
        </div>
      </div>
    </footer>
  );
}
